import set from 'lodash/set';

import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

import { NannyFrontOfficeState } from './types';

export interface NannyAlertAction {
    violations: NannyFrontOfficeState['violations'];
    more: NannyFrontOfficeState['more'];
}

export const initialState: NannyFrontOfficeState = {
    isAlertDisplayed: false,
    violations: [],
    more: false,
    error: undefined,
    saveCallback: undefined,
};

const slice = createSlice({
    domain: 'nanny',
    initialState,
    reducers: {
        displayNannyAlert: (state: NannyFrontOfficeState, action: PayloadAction<NannyAlertAction>): void => {
            set(state, 'violations', action.payload.violations);
            set(state, 'more', action.payload.more);
            set(state, 'isAlertDisplayed', true);
        },
        hideNannyAlert: (state: NannyFrontOfficeState): void => {
            set(state, 'violations', initialState.violations);
            set(state, 'more', initialState.more);
            set(state, 'isAlertDisplayed', false);
            set(state, 'saveCallback', initialState.saveCallback);
        },
        setError: (state: NannyFrontOfficeState, action: PayloadAction<string>): void => {
            set(state, 'error', action.payload);
        },
        resetError: (state: NannyFrontOfficeState): void => {
            set(state, 'error', initialState.error);
        },
        setSaveCallback: (state: NannyFrontOfficeState, action: PayloadAction<(() => void) | undefined>): void => {
            set(state, 'saveCallback', action.payload);
        },
    },
});

const { actions, reducer } = slice;

export { actions, reducer };
